module.exports = __webpack_public_path__ + "img/skip-end.82ff9dc7.svg";